import axios from "axios"
import {formatDateVanilla} from "../../utils/util";

const STEP_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/reports/care-path-step-name-filter";
const DETAILED_REPORT_URL = process.env.REACT_APP_REST_API_BASE_URL + "/v1/reports/care-path-step-report/detailed";

export const getStepNameFilter = (clientId) => {
    if (typeof clientId === 'undefined') clientId = "";
    const sanitizedClientId = encodeURIComponent(clientId);
    return axios.get(
        `${STEP_URL}?clientId=${sanitizedClientId}`
    );
}

export const getDetailedReport = (stepName, page, dateRange) => {
    const sanitizedStepName = stepName;
    const sanitizedPage = page;
    const sanitizedStartDate = formatDateVanilla(dateRange[0], 'yyyy-MM-dd');
    const sanitizedEndDate = formatDateVanilla(dateRange[1], 'yyyy-MM-dd');

    return axios.post(DETAILED_REPORT_URL, {
        stepName: sanitizedStepName,
        pageSize: 20,
        pageNumber: sanitizedPage,
        startDate: sanitizedStartDate,
        endDate: sanitizedEndDate
    }, {
        headers: {
          "Content-Type": "application/json",
        },
    });
}